import { Link } from 'react-router-dom';
import LuxPageHero from '../components/lux/LuxPageHero';
import LuxReveal from '../components/lux/LuxReveal';
import LuxCta from '../components/lux/LuxCta';
import { Icon } from '../components/ui/Icons';

const mvCards = [
  { title: 'Our Vision', icon: 'globe', desc: 'Global recognition as a premier industrial training institute delivering cutting-edge skills.' },
  { title: 'Our Mission', icon: 'target', desc: 'Empower students with practical training aligned with Industry 4.0 and real factory workflows.' },
  { title: 'Core Values', icon: 'award', desc: 'Innovation, integrity, and an unwavering commitment to student success.' },
  { title: 'Our Goals', icon: 'zap', desc: 'Strong industry partnerships and sustainable career paths for every learner.' },
];

const milestones = [
  { year: '2018', event: 'Founded in Noida Sector-3 to bridge the industrial skills gap.' },
  { year: '2019', event: 'Launched PLC/SCADA programs with real hardware labs.' },
  { year: '2021', event: 'Expanded to IT & Data Science — 200+ students placed.' },
  { year: '2023', event: '95% placement rate. Added SAP, Full Stack, Embedded Systems.' },
  { year: '2025', event: '500+ alumni working across India\'s top companies.' },
];

export default function About() {
  return (
    <>
      <LuxPageHero label="Our Story" title="Empowering" highlight="Industrial Skills" description="Bridging academic learning and professional excellence since 2018." />

      <section className="lux-page-section">
        <div className="container-wide lux-grid-2 about-grid">
          <LuxReveal>
            <p className="lux-statement__eyebrow">Who we are</p>
            <h2 className="video-gallery__title" style={{ fontSize: 'clamp(1.8rem, 4vw, 2.5rem)', marginTop: 12 }}>
              Bharat <em style={{ fontStyle: 'italic', color: 'var(--accent-soft)' }}>Industrial Training</em>
            </h2>
            <p style={{ color: 'var(--text-secondary)', marginTop: 20, lineHeight: 1.85 }}>
              Noida&apos;s premier institute for hands-on PLC, SCADA, automation, SAP and IT training — built for Industry 4.0 careers.
            </p>
            <div style={{ display: 'flex', gap: 28, marginTop: 32, flexWrap: 'wrap' }}>
              {[['500+', 'Students'], ['100%', 'Placed'], ['16+', 'Programs']].map(([v, l]) => (
                <div key={l}>
                  <div className="lux-stats__num" style={{ fontSize: '2rem' }}>{v}</div>
                  <div className="lux-stats__label">{l}</div>
                </div>
              ))}
            </div>
            <Link to="/admission" className="btn-lux btn-lux--fill" style={{ marginTop: 32, display: 'inline-flex', color: '#030712' }}>Free Counselling</Link>
          </LuxReveal>
          <LuxReveal delay={0.15} x={30}>
            <div style={{ position: 'relative' }}>
              <img src="/pl2.jpeg" alt="Bharat Training campus" style={{ width: '100%', height: 420, objectFit: 'cover', border: '1px solid var(--border)' }} />
              <div style={{ position: 'absolute', bottom: 20, left: 20, padding: '14px 20px', background: 'var(--grad-btn)', color: '#fff' }}>
                <strong style={{ fontFamily: 'var(--font-display)' }}>Sector-3, Noida</strong>
                <div style={{ fontSize: 12, opacity: 0.85 }}>Near Sector-16 Metro</div>
              </div>
            </div>
          </LuxReveal>
        </div>
      </section>

      <section className="lux-page-section" style={{ background: 'var(--bg-elevated)' }}>
        <div className="container-wide lux-grid-4">
          {mvCards.map((c, i) => (
            <LuxReveal key={c.title} delay={i * 0.08}>
              <div className="lux-card">
                <div className="icon-wrap" style={{ marginBottom: 16 }}><Icon name={c.icon} size={20} /></div>
                <h3 style={{ fontFamily: 'var(--font-display)', fontWeight: 700, marginBottom: 10, color: 'var(--accent-soft)' }}>{c.title}</h3>
                <p style={{ fontSize: 14, color: 'var(--text-muted)', lineHeight: 1.7 }}>{c.desc}</p>
              </div>
            </LuxReveal>
          ))}
        </div>
      </section>

      <section className="lux-page-section">
        <div className="container-wide">
          <LuxReveal>
            <h2 className="video-gallery__title" style={{ textAlign: 'center', marginBottom: 56 }}>Our <em style={{ fontStyle: 'italic', color: 'var(--accent-soft)' }}>journey</em></h2>
          </LuxReveal>
          <div className="lux-timeline">
            {milestones.map((m, i) => (
              <LuxReveal key={m.year} delay={i * 0.08}>
                <div className="lux-timeline__item">
                  <div className="lux-timeline__year">{m.year}</div>
                  <div className="lux-card" style={{ flex: 1, marginTop: 8 }}>
                    <p style={{ color: 'var(--text-secondary)', lineHeight: 1.7 }}>{m.event}</p>
                  </div>
                </div>
              </LuxReveal>
            ))}
          </div>
        </div>
      </section>

      <section className="lux-page-section" style={{ background: 'var(--bg-elevated)' }}>
        <div className="container-wide" style={{ textAlign: 'center' }}>
          <LuxReveal>
            <p className="lux-statement__eyebrow">Leadership</p>
            <h2 className="video-gallery__title">Meet our <em style={{ fontStyle: 'italic', color: 'var(--accent-soft)' }}>founder</em></h2>
          </LuxReveal>
          <LuxReveal delay={0.15}>
            <div className="lux-card" style={{ maxWidth: 360, margin: '48px auto 0', textAlign: 'center' }}>
              <img src="/lata.jpeg" alt="Lata Joshi" style={{ width: 120, height: 120, borderRadius: '50%', objectFit: 'cover', margin: '0 auto 20px', border: '2px solid var(--accent)' }} />
              <h3 style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: '1.25rem' }}>Lata Joshi</h3>
              <p style={{ color: 'var(--accent)', fontSize: 12, letterSpacing: '0.12em', textTransform: 'uppercase', margin: '8px 0 16px' }}>Founder & Director</p>
              <p style={{ color: 'var(--text-muted)', fontSize: 14, lineHeight: 1.75 }}>15+ years in industrial automation and vocational training.</p>
              <a href="tel:+918851868521" className="btn-lux btn-lux--line" style={{ marginTop: 24, display: 'inline-flex', color: 'var(--text)' }}>
                <Icon name="phone" size={16} /> +91 88518 68521
              </a>
            </div>
          </LuxReveal>
        </div>
      </section>

      <LuxCta title="Join Bharat" highlight="Training" />
    </>
  );
}
